export default __webpack_public_path__ + "static/media/useredit.aea9432e.svg";